import { Link } from "react-router-dom";
import { Phone, MapPin, Facebook, Instagram, ArrowUpRight } from "lucide-react";
import Logo from "./Logo";
import { WhatsAppGlyph } from "./FloatingWhatsApp";
import { COMPANY } from "../data/company";
import { generalWhatsappLink } from "../utils/whatsapp";

const QUICK_LINKS = [
  { to: "/", label: "Inicio" },
  { to: "/nosotros", label: "Nosotros" },
  { to: "/productos", label: "Productos" },
  { to: "/contacto", label: "Contacto" },
];

export default function Footer() {
  return (
    <footer className="relative bg-brand-ink text-white overflow-hidden" data-testid="footer">
      <div className="absolute inset-0 noise-overlay opacity-[0.06] pointer-events-none" aria-hidden="true" />
      <div className="container-mw relative py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="lg:col-span-1">
            <Logo variant="blue-on-dark" />
            <p className="mt-6 text-sm leading-relaxed text-white/60 max-w-xs">
              {COMPANY.shortDesc}
            </p>
          </div>

          <div>
            <h3 className="font-display font-semibold text-sm uppercase tracking-[0.2em] text-brand-gold">
              Navegación
            </h3>
            <ul className="mt-6 space-y-3">
              {QUICK_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="text-white/70 hover:text-white transition-colors duration-300 text-sm inline-flex items-center gap-1 group"
                  >
                    {l.label}
                    <ArrowUpRight className="h-3.5 w-3.5 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-display font-semibold text-sm uppercase tracking-[0.2em] text-brand-gold">
              Contacto
            </h3>
            <ul className="mt-6 space-y-4 text-sm text-white/70">
              <li>
                <a href={`tel:+${COMPANY.phoneRaw}`} className="flex items-start gap-3 hover:text-white transition-colors" data-testid="footer-phone">
                  <Phone className="h-4 w-4 mt-0.5 text-brand-gold shrink-0" />
                  {COMPANY.phoneDisplay}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 mt-0.5 text-brand-gold shrink-0" />
                {COMPANY.location}
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-display font-semibold text-sm uppercase tracking-[0.2em] text-brand-gold">
              Seguinos
            </h3>
            <div className="mt-6 flex flex-col gap-3">
              <a
                href={generalWhatsappLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                className="inline-flex items-center gap-2.5 rounded-full bg-white/5 border border-white/10 px-4 py-2.5 text-sm hover:border-brand-whatsapp hover:text-brand-whatsapp transition-colors duration-300"
              >
                <WhatsAppGlyph className="h-4 w-4" /> WhatsApp
              </a>
              <a
                href={COMPANY.facebook}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook"
                className="inline-flex items-center gap-2.5 rounded-full bg-white/5 border border-white/10 px-4 py-2.5 text-sm hover:border-brand-blue hover:text-brand-blue transition-colors duration-300"
              >
                <Facebook className="h-4 w-4" /> Facebook
              </a>
              <a
                href={COMPANY.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="inline-flex items-center gap-2.5 rounded-full bg-white/5 border border-white/10 px-4 py-2.5 text-sm hover:border-brand-gold hover:text-brand-gold transition-colors duration-300"
              >
                <Instagram className="h-4 w-4" /> Instagram
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            © {new Date().getFullYear()} {COMPANY.name}. Todos los derechos reservados. {COMPANY.legalTagline}.
          </p>
          <p className="text-xs text-white/40 font-display uppercase tracking-[0.2em]">
            Precisión en Bronce
          </p>
        </div>
      </div>
    </footer>
  );
}
